{
	"header": {
		"taskCount": "{{count}} tasks"
	},
	"nav": {
		"backToPlatform": "Back to kiss.cat",
		"apps": "Apps",
		"account": "Account",
		"accounts": "Accounts",
		"addAccount": "Add account",
		"profile": "Profile",
		"signOut": "Sign out",
		"sections": "Sections",
		"expand": "Expand sidebar",
		"collapse": "Collapse sidebar",
		"openMenu": "Open menu",
		"closeMenu": "Close menu",
		"board": "Board",
		"backlog": "Backlog",
		"epics": "Epics",
		"breadcrumb": "Breadcrumb",
		"live": "Archive",
		"insights": "Insights",
		"settings": "Settings",
		"skipToContent": "Skip to content",
		"home": "Home",
		"primary": "Primary",
		"expandNav": "Expand navigation",
		"collapseNav": "Collapse navigation"
	},
	"theme": {
		"toggle": "Switch theme",
		"light": "Light",
		"dark": "Dark"
	},
	"board": {
		"quickAdd": "Add a task",
		"quickAddLabel": "Add a task to {{status}}",
		"archiveDone": "Archive all Done",
		"columnEmpty": "No tasks",
		"columns": "Columns",
		"changeAssignee": "Change assignee",
		"empty": {
			"title": "No board yet",
			"description": "Sign in to the workspace to see its tasks."
		},
		"a11y": {
			"board": "Task board",
			"lifted": "Picked up {{task}}.",
			"over": "Moving {{task}} over {{column}}.",
			"dropped": "Dropped {{task}} into {{column}}.",
			"reordered": "Dropped {{task}}.",
			"cancelled": "Cancelled moving {{task}}."
		}
	},
	"epics": {
		"status": {
			"PLANNED": "Planned",
			"ACTIVE": "Active",
			"DONE": "Done"
		},
		"new": "New epic",
		"count": "{{count}} epics",
		"searchEpics": "Search epics",
		"chipLabel": "{{key}} · {{name}}",
		"groupByEpic": "Group by epic",
		"groupedByEpic": "Grouped by epic",
		"ungroup": "Stop grouping by epic",
		"noEpicLane": "No epic",
		"laneLabel": "{{key}} · {{name}}",
		"created": "Epic created",
		"quickAdd": "Add an epic",
		"quickAddLabel": "Add an epic to {{status}}",
		"statusLabel": "Epic status",
		"filterOwner": "Owner",
		"anyOwner": "Any owner",
		"showArchived": "Show archived",
		"archiveDone": "Archive all Done",
		"columnEmpty": "No epics",
		"tasks": "tasks",
		"progress": "{{done}} of {{total}} tasks done",
		"breakdown": "{{total}} tasks. {{summary}}.",
		"breakdownBacklog": "{{count}} in the backlog",
		"breakdownActive": "{{count}} active",
		"breakdownDone": "{{count}} done",
		"breakdownArchived": "{{count}} archived",
		"pick": "Assign an epic",
		"none": "No epic",
		"createNew": "Create a new epic",
		"noTasks": "No tasks",
		"name": "Epic name",
		"namePlaceholder": "e.g. Billing clarity",
		"nameRequired": "Enter a name",
		"nameTooLong": "Keep the name under {{max}} characters",
		"colour": "Colour",
		"brief": "Brief",
		"briefTooLong": "Keep the brief under {{max}} characters",
		"create": "Create epic",
		"description": "Epic description",
		"descriptionPlaceholder": "Add a description",
		"owner": "Owner",
		"noOwner": "No owner",
		"changeOwner": "Change owner",
		"backToOverview": "Back to epics",
		"assignee": "Assignee",
		"assignees": "Assignees",
		"moreAssignees": "+{{count}} more",
		"archivedBadge": "Archived",
		"archivedTag": "Archived",
		"conflictReloaded": "This epic changed somewhere else, so we reloaded the latest.",
		"menu": "Epic actions",
		"archive": "Archive epic",
		"unarchive": "Unarchive epic",
		"delete": "Delete epic",
		"deleteTitle": "Delete this epic?",
		"deleteBody": "This removes the epic and unfiles its tasks. The tasks themselves are not deleted. This cannot be undone.",
		"cancel": "Cancel",
		"empty": {
			"title": "No epics yet",
			"description": "Sign in to the workspace to see its epics."
		},
		"notFound": {
			"title": "Epic not found",
			"description": "This epic may have been deleted, or you may not have access to it."
		},
		"overviewEmpty": {
			"title": "No epics yet",
			"description": "Group related tasks into an epic to plan and track a bigger piece of work in one place."
		},
		"overviewNoMatches": {
			"title": "No epics match",
			"description": "No epics match your search or owner filter. Clear them to see them all."
		},
		"boardEmpty": {
			"title": "No tasks in this epic yet",
			"description": "Add the first task and it shows up on this epic's board."
		}
	},
	"status": {
		"TODO": "To Do",
		"IN_PROGRESS": "In Progress",
		"REVIEW": "Review",
		"TEST": "Test",
		"DONE": "Done",
		"BACKLOG": "Backlog",
		"LIVE": "Archived"
	},
	"type": {
		"FEATURE": "Feature",
		"BUG": "Bug",
		"CHORE": "Chore",
		"SPIKE": "Spike"
	},
	"priority": {
		"URGENT": "Urgent",
		"HIGH": "High",
		"MEDIUM": "Medium",
		"LOW": "Low",
		"NONE": "None"
	},
	"due": {
		"title": "Due date",
		"overdue": "Overdue"
	},
	"action": {
		"promote": "Move to To Do",
		"advance": "Advance",
		"markDone": "Mark done",
		"moveBacklog": "Move to backlog",
		"ship": "Archive",
		"unship": "Restore to To Do",
		"assignMe": "Assign to me",
		"more": "More actions"
	},
	"edit": {
		"title": "Task title",
		"titleHint": "Double-click to rename",
		"save": "Save changes",
		"saveHint": "Cmd/Ctrl+Enter to save",
		"descriptionPlaceholder": "Add more detail",
		"openFull": "Open full page",
		"collapse": "Collapse to side panel",
		"close": "Close",
		"unassigned": "Unassigned",
		"conflictReloaded": "This task changed somewhere else, so we reloaded the latest.",
		"menu": "Task actions",
		"delete": "Delete task",
		"deleteTitle": "Delete this task?",
		"deleteBody": "This removes the task from the board and its lists for everyone. This cannot be undone.",
		"cancel": "Cancel",
		"field": {
			"assignee": "Assignee",
			"labels": "Labels",
			"epic": "Epic",
			"epicAdd": "Add"
		}
	},
	"create": {
		"new": "New task",
		"more": "More create options",
		"title": "New task",
		"titlePlaceholder": "What needs doing?",
		"hint": "Cmd/Ctrl+Enter to save & new",
		"save": "Create task",
		"field": {
			"title": "Title",
			"type": "Type",
			"status": "Status",
			"priority": "Priority",
			"dueDate": "Due date",
			"description": "Description"
		}
	},
	"filter": {
		"button": "Filters",
		"buttonActive": "Filters ({{count}})",
		"clear": "Clear",
		"search": "Search tasks",
		"type": "Type",
		"anyType": "Any type",
		"priority": "Priority",
		"anyPriority": "Any priority",
		"label": "Label",
		"anyLabel": "Any label",
		"epic": "Epic",
		"anyEpic": "Any epic",
		"assignee": "Assignee",
		"anyone": "Anyone",
		"me": "Me",
		"meNamed": "Me · {{name}}",
		"by": "Filter by",
		"back": "Back",
		"clearAll": "Clear all",
		"searchField": "Search {{field}}",
		"noMatches": "No matches",
		"searchChip": "Search:",
		"clearSearch": "Clear search",
		"removeField": "Remove {{field}}"
	},
	"projects": {
		"title": "Projects",
		"subtitle": "Each board is a project. Give it a name and set a colour for it.",
		"switch": "Switch project",
		"manage": "Manage projects",
		"name": "Name",
		"namePlaceholder": "e.g. Growth",
		"nameRequired": "Enter a name",
		"add": "Add project",
		"save": "Save",
		"cancel": "Cancel",
		"actions": "Board actions",
		"edit": "Edit",
		"delete": "Delete",
		"deleteTitle": "Delete this board?",
		"deleteBody": "This removes the board and all of its tasks. This cannot be undone.",
		"archive": "Archive",
		"restore": "Restore",
		"loading": "Loading projects",
		"empty": {
			"title": "No projects yet",
			"description": "Add your first board above."
		},
		"archived": {
			"title": "Archived",
			"note": "Archived boards are hidden from the navigation. Restore one to bring it back."
		}
	},
	"members": {
		"title": "Team",
		"body": "Members and invites are managed in your account settings.",
		"manage": "Manage members"
	},
	"labels": {
		"title": "Labels",
		"subtitle": "Shared, colour-coded tags for tasks across all of your projects.",
		"add": "Add label",
		"name": "Name",
		"namePlaceholder": "e.g. Urgent",
		"nameRequired": "Enter a name",
		"colour": "Colour",
		"colourSwatch": "Colour {{name}}",
		"custom": "Custom",
		"customColour": "Custom colour",
		"save": "Save",
		"cancel": "Cancel",
		"edit": "Edit",
		"delete": "Delete",
		"confirmDelete": "Delete?",
		"loading": "Loading labels",
		"pick": "Toggle labels",
		"pickerEmpty": "No labels yet. Add your first below.",
		"pickerManage": "Manage labels",
		"empty": {
			"title": "No labels yet",
			"description": "Add your first label above."
		}
	},
	"voice": {
		"start": "Dictate a task",
		"stop": "Stop dictation",
		"starting": "Starting",
		"listening": "Listening",
		"transcript": "Transcript",
		"prompt": "Speak your task and it fills the form",
		"structuring": "Structuring your task",
		"creating": "Creating your task",
		"capped": "Reached the dictation time limit.",
		"fallback": {
			"title": "Could not structure that",
			"body": "Put your words in the description. Edit and save."
		}
	},
	"workspace": {
		"title": "Workspace",
		"ai": {
			"label": "AI features",
			"description": "Dictate a task and get a structured draft, plus live transcription. Audio is never stored.",
			"adminOnly": "Only an admin can change this."
		}
	},
	"backlog": {
		"title": "Backlog",
		"empty": {
			"title": "Backlog is empty",
			"description": "Add a task above to get started."
		}
	},
	"live": {
		"title": "Archive",
		"count": "{{count}} shipped",
		"loadMore": "Load more",
		"loadingMore": "Loading",
		"empty": {
			"title": "Nothing archived yet",
			"description": "Archive a Done task and it lands here."
		}
	},
	"search": {
		"title": "Search tasks",
		"placeholder": "Search all tasks",
		"none": "No matching tasks"
	},
	"comment": {
		"heading": "Comments",
		"empty": "No comments yet.",
		"label": "Comment",
		"placeholder": "Write a comment. Use @ to mention someone",
		"submit": "Comment",
		"save": "Save",
		"cancel": "Cancel",
		"edit": "Edit",
		"delete": "Delete",
		"confirmDelete": "Delete?",
		"edited": "edited",
		"via": "via {{agent}}",
		"yourAgents": "Your agents",
		"people": "People"
	},
	"checklist": {
		"heading": "Checklist",
		"placeholder": "Add an item",
		"placeholderFirst": "Add the first item",
		"add": "Add",
		"delete": "Delete",
		"deleteConfirm": "Tap again to remove",
		"editHint": "Click to edit",
		"completed": "Completed",
		"emptyTitle": "No checklist yet",
		"emptyBody": "Break this task into smaller steps and tick them off as you go."
	},
	"links": {
		"heading": "Links",
		"placeholder": "Paste a URL, like a PR, doc, or design",
		"add": "Add",
		"open": "Open in new tab",
		"remove": "Remove",
		"empty": "No links yet.",
		"pr": {
			"open": "Open",
			"merged": "Merged",
			"closed": "Closed",
			"draft": "Draft"
		}
	},
	"relations": {
		"heading": "Relations",
		"parent": "Parent",
		"subtasks": "Sub-tasks",
		"blocks": "Blocks",
		"blockedBy": "Blocked by",
		"related": "Related",
		"setParent": "Set parent",
		"addSubtask": "Add sub-task",
		"add": "Add",
		"remove": "Remove",
		"searchPlaceholder": "Search by key or title",
		"searchNone": "No matching tasks",
		"subtaskBadge_one": "{{count}} sub-task",
		"subtaskBadge_other": "{{count}} sub-tasks",
		"blockedBadge_one": "Blocked by {{count}} task",
		"blockedBadge_other": "Blocked by {{count}} tasks"
	},
	"recurrence": {
		"title": "Repeats",
		"badge": "Repeats",
		"subtitleOn": "A fresh copy is created when this is completed.",
		"subtitleOff": "Turn on to make a fresh copy each time you finish this task.",
		"repeatWhen": "Repeat when",
		"every": "Every",
		"mode": {
			"onCompletion": "Completed",
			"onSchedule": "On schedule"
		},
		"cadence": {
			"DAILY-1": "Daily",
			"WEEKLY-1": "Weekly",
			"WEEKLY-2": "Every 2 weeks",
			"MONTHLY-1": "Monthly"
		},
		"fromDone": "from the day it's done",
		"fromDue": "from the due date",
		"noteCompletion": "Finish this and a fresh copy opens, keeping one open copy at a time. Nothing to schedule.",
		"noteSchedule": "A fresh copy opens on the cadence, whether or not this one is done.",
		"hintOff": "Opinionated by default: repeats on completion, keeping only one open copy at a time. Tweak the cadence after you switch it on."
	},
	"spec": {
		"heading": "Spec",
		"history": "History",
		"edit": "Edit",
		"placeholder": "Write the spec the agent builds against",
		"cancel": "Cancel",
		"save": "Save version",
		"viewingOld": "Viewing an older version.",
		"backToCurrent": "Back to current",
		"committedBy": "v{{version}} by {{name}} · {{when}}",
		"empty": "No spec yet. Capture the plan the agent will build against.",
		"write": "Write the spec"
	},
	"attach": {
		"heading": "Attachments",
		"add": "Add files",
		"dropHint": "Drop files here, or use Add files",
		"uploading": "Uploading",
		"file": "File",
		"open": "Open {{name}}",
		"delete": "Delete",
		"confirmDelete": "Delete?"
	},
	"activity": {
		"heading": "Activity",
		"someone": "Someone",
		"today": "Today",
		"yesterday": "Yesterday",
		"created": "created this task",
		"title": "changed the title",
		"description": "edited the description",
		"type": "changed type from {{from}} to {{to}}",
		"spec": "updated the plan",
		"status": "changed status from {{from}} to {{to}}",
		"priority": "changed priority from {{from}} to {{to}}",
		"assigned": "assigned {{name}}",
		"unassigned": "removed the assignee",
		"due": "set the due date to {{date}}",
		"dueCleared": "cleared the due date",
		"labels": "updated labels",
		"labelsAdded": "added {{added}}",
		"labelsRemoved": "removed {{removed}}",
		"labelsBoth": "added {{added}}, removed {{removed}}",
		"epicSet": "filed under {{epic}}",
		"epicCleared": "removed from {{epic}}",
		"epicMoved": "moved from {{from}} to {{to}}",
		"someEpic": "an epic",
		"commented": "commented",
		"assignedAgent": "assigned {{agent}} ({{owner}})",
		"ownerAgent": "{{owner}}'s agent",
		"unassignedAgent": "removed the agent assignee"
	},
	"notif": {
		"title": "Notifications",
		"titleCount": "Notifications ({{count}} unread)",
		"unreadNone": "No new notifications",
		"unreadLabel_one": "{{count}} new notification",
		"unreadLabel_other": "{{count}} new notifications",
		"markAll": "Mark all read",
		"empty": "Nothing yet.",
		"assigned": "{{actor}} assigned you {{task}}",
		"ticketAssigned": "{{actor}} assigned you {{ticket}}",
		"ticketReplied": "New reply on {{ticket}}",
		"mentioned": "{{actor}} mentioned you in {{task}}",
		"commented": "{{actor}} commented on {{task}}",
		"tabYou": "You",
		"tabAgents": "Agents",
		"emptyAgents": "Your agents are all caught up.",
		"forAgent": "For {{agent}}",
		"viaAgent": "{{actor}} via {{agent}}",
		"markAgentRead": "Mark read",
		"clearAgents": "Clear all"
	},
	"views": {
		"button": "Views",
		"title": "Saved views",
		"empty": "No saved views yet.",
		"name": "View name",
		"namePlaceholder": "Name this view",
		"save": "Save",
		"delete": "Delete view",
		"shared": "Shared",
		"share": "Share",
		"unshare": "Unshare",
		"shareWithWorkspace": "Share with workspace"
	},
	"cmd": {
		"title": "Command palette",
		"placeholder": "Type a command or search tasks",
		"none": "No matches",
		"newTask": "New task",
		"newEpic": "Create epic",
		"board": "Go to Board",
		"backlog": "Go to Backlog",
		"live": "Go to Archive",
		"settings": "Go to Settings",
		"switchProject": "Switch to {{name}}"
	},
	"palette": {
		"navigate": "Navigate",
		"open": "Open",
		"close": "Close"
	},
	"settings": {
		"title": "Settings",
		"subtitle": "Manage your preferences and workspace.",
		"tabs": {
			"account": "Preferences",
			"workspace": "Workspace"
		},
		"account": {
			"profile": {
				"title": "Profile",
				"description": "Your name and avatar are part of your account, shared across all of kiss.cat.",
				"link": "Edit profile"
			}
		}
	},
	"reporting": {
		"title": "Insights",
		"subtitle": "Pick a metric, slice it, then drill in.",
		"metricsLabel": "Metrics",
		"rangeLabel": "Time range",
		"loading": "Loading insights",
		"unassigned": "Unassigned",
		"metric": {
			"throughput": "Throughput",
			"velocity": "Velocity",
			"status": "Status",
			"cycleTime": "Cycle time",
			"workload": "Workload"
		},
		"metricDesc": {
			"throughput": "Tasks completed per bucket",
			"velocity": "Tasks shipped per bucket",
			"status": "Where tasks sit right now",
			"cycle-time": "Time from started to done",
			"workload": "Open and completed work per person"
		},
		"project": {
			"label": "Project",
			"all": "All projects"
		},
		"groupBy": {
			"label": "Group by",
			"assignee": "Assignee",
			"project": "Project",
			"none": "None"
		},
		"range": {
			"7d": "7d",
			"30d": "30d",
			"90d": "90d"
		},
		"summary": {
			"completed": "Completed",
			"inProgress": "In progress",
			"overdue": "Overdue"
		},
		"stat": {
			"context": "This metric",
			"perBucket": "Average per bucket",
			"total": "Total tasks",
			"assignees": "Assignees"
		},
		"cycle": {
			"avg": "Average, started to done",
			"p50": "Median (p50)",
			"p90": "p90",
			"tasks": "Tasks measured"
		},
		"workload": {
			"inProgress": "In progress",
			"done": "Done"
		},
		"drill": {
			"assignee": "Contribution by assignee",
			"project": "Contribution by project",
			"none": "Contribution",
			"sub": "Share of the {{total}} completed"
		},
		"empty": {
			"title": "Not enough data yet",
			"description": "This metric needs a little more activity in the selected range. Try a wider range or another project."
		}
	},
	"notFound": {
		"badge": "404",
		"title": "Page not found",
		"description": "That page has moved or never existed. Check the link, or head back to your board.",
		"home": "Back to the board"
	},
	"error": {
		"badge": "Error",
		"title": "Something went wrong",
		"description": "An unexpected error broke this page. Head back to your board and pick up where you left off.",
		"home": "Back to the board"
	},
	"update": {
		"title": "Update available",
		"description": "A newer version is ready. Reload to get it.",
		"reload": "Reload",
		"dismiss": "Dismiss"
	},
	"prefs": {
		"title": "Display",
		"open": {
			"label": "Open tasks in",
			"description": "What a task opens as when you click it on the board.",
			"panel": "Side panel",
			"page": "Full page"
		}
	},
	"defaultProject": {
		"title": "Default project",
		"label": "Open the app on",
		"description": "The board you land on when you open KissCat."
	},
	"emailNotifications": {
		"title": "Email notifications",
		"label": "Email me when I am assigned a task or mentioned",
		"description": "Sends an email for assignments and mentions. Your in-app notifications are unaffected."
	},
	"shortcuts": {
		"title": "Keyboard shortcuts",
		"hint": "Shortcuts pause while you are typing in a field.",
		"overlayHint": "Press ? anytime to open this list.",
		"newTask": "New task",
		"commandPalette": "Command palette",
		"search": "Search tasks",
		"openTask": "Open the focused task",
		"editTask": "Edit the focused task",
		"promote": "Move a backlog task to the board",
		"markDone": "Mark the focused task done",
		"shipTask": "Archive a done task",
		"saveNew": "Save (or save and create another)",
		"dictate": "Stop dictation and submit, or start it",
		"cancel": "Close or cancel",
		"help": "Show this cheat sheet",
		"navigate": "Move between cards",
		"moveColumn": "Move the card to column 1–7",
		"group": {
			"global": "Anywhere",
			"list": "Board and backlog",
			"board": "On the board",
			"create": "Creating a task"
		}
	},
	"task": {
		"title": "Task",
		"back": "Board",
		"noDescription": "No description yet.",
		"meta": {
			"status": "Status",
			"type": "Type",
			"labels": "Labels",
			"unassigned": "Unassigned",
			"none": "None"
		},
		"edit": "Edit"
	},
	"assignee": {
		"people": "People",
		"yourAgents": "Your agents",
		"yourAgent": "Your agent",
		"agent": "Agent",
		"via": "via",
		"agentAlt": "{{owner}}'s agent {{agent}}"
	},
	"onboarding": {
		"title": "Getting started",
		"greeting": "Welcome to KISS.cat, {{name}}",
		"greetingNoName": "Welcome to KISS.cat",
		"subtitle": "A few quick things to get your board going.",
		"progress": "{{done}} of {{total}} done",
		"pill": "{{title}} · {{done}}/{{total}}",
		"minimise": "Minimise",
		"dismiss": "Don't show this again",
		"optional": "optional",
		"step": {
			"account": {
				"title": "Create your account"
			},
			"task": {
				"title": "Add your first task",
				"description": "Write down anything you need to do.",
				"cta": "Do it"
			},
			"agent": {
				"title": "Connect your coding agent",
				"description": "Claude Code, Cursor, any MCP client.",
				"cta": "Connect"
			},
			"invite": {
				"title": "Invite a teammate",
				"description": "Optional. Starts a team, adds a seat and moves you to a team plan.",
				"cta": "Invite"
			}
		}
	},
	"copy": {
		"id": "Copy ID",
		"link": "Copy link",
		"copiedId": "Copied {{id}}",
		"copiedLink": "Link copied",
		"failed": "Could not copy",
		"aria": "Copy {{id}}",
		"hint": "Copy ID",
		"hintMenu": "Copy ID (right-click or press ↓ for the link)"
	},
	"meta": {
		"root": {
			"title": "KissCat Tasks",
			"description": "Plan, track, and ship your work in KissCat Tasks."
		},
		"settings": {
			"title": "Settings · KissCat Tasks",
			"description": "Workspace settings"
		},
		"preferences": {
			"title": "Preferences · Settings · KissCat Tasks",
			"description": "Your personal preferences"
		},
		"workspace": {
			"title": "Workspace · Settings · KissCat Tasks",
			"description": "Workspace administration"
		},
		"reporting": {
			"title": "Insights · KissCat Tasks",
			"description": "Reporting and insights"
		},
		"board": {
			"title": "Board · KissCat Tasks",
			"description": "Task board"
		},
		"backlog": {
			"title": "Backlog · KissCat Tasks",
			"description": "Task backlog"
		},
		"live": {
			"title": "Archive · KissCat Tasks",
			"description": "Archived completed tasks"
		},
		"epics": {
			"title": "Epics · KissCat Tasks",
			"description": "Group work into epics"
		},
		"epicDetail": {
			"title": "Epic · KissCat Tasks",
			"description": "Epic detail"
		}
	},
	"a11y": {
		"close": "Close",
		"dismiss": "Dismiss",
		"imagePreview": "Image preview"
	},
	"field": {
		"moreInfo": "More information"
	},
	"loadError": {
		"retry": "Try again",
		"reload": "Reload page",
		"cold": "Your tasks are safe — check your connection and try again.",
		"stale": "Showing the last version from a moment ago.",
		"board": {
			"cold": "Couldn’t load the board",
			"refresh": "Couldn’t refresh the board"
		},
		"backlog": {
			"cold": "Couldn’t load the backlog",
			"refresh": "Couldn’t refresh the backlog"
		},
		"archive": {
			"cold": "Couldn’t load the archive",
			"refresh": "Couldn’t refresh the archive"
		},
		"insights": {
			"cold": "Couldn’t load insights",
			"refresh": "Couldn’t refresh insights"
		},
		"task": {
			"cold": "Couldn’t load this task",
			"refresh": "Couldn’t refresh this task"
		},
		"epics": {
			"cold": "Couldn’t load epics",
			"refresh": "Couldn’t refresh epics"
		}
	}
}
